/**
 * Demo script registry — drop new categories into this map and the engine
 * picks them up automatically.
 *
 * To add a new category (e.g. roofing):
 *   1. Create scripts/roofing.js (copy grocery.js as a template)
 *   2. Import it below and add to the map
 *   3. Visit /demo/play/roofing to test
 */
import grocery from "./grocery";
import wholesale from "./wholesale";
import mechanic from "./mechanic";

const scripts = {
  grocery,
  wholesale,
  mechanic,
};

export default scripts;
